export const MAX_GROUP_NAME_LENGTH = 50
export const MAX_GROUP_DESCRIPTION_LENGTH = 500
